import { Link } from "@tanstack/react-router";
import { cn } from "@/lib/utils";
import {
  GESTAO_LINK_LABEL,
  GESTAO_URL,
  SENSITIVE_FIELDS_ADMIN_NOTICE,
  SENSITIVE_FIELDS_LOCKED_NOTICE,
  SENSITIVE_FIELDS_SUPPORT_HINT,
  SENSITIVE_FIELDS_SUPPORT_LINK_LABEL,
} from "@/lib/sensitive-field-errors";

type Props = {
  /** `locked`: campos somente leitura. `admin`: ficha administrativa. `error`: falha ao salvar. */
  variant?: "locked" | "admin" | "error";
  /** Mensagem exibida na variante `error`. */
  message?: string | null;
  id?: string;
  className?: string;
};

/** Link externo padronizado para a Gestão de cadastros. */
function GestaoLink({ className }: { className?: string }) {
  return (
    <a
      href={GESTAO_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={cn("inline-block py-1 font-medium text-primary underline", className)}
    >
      {GESTAO_LINK_LABEL}
    </a>
  );
}

/** Aviso padronizado sobre nome, CPF e data de nascimento (somente leitura aqui). */
export function SensitiveFieldsNotice({ variant = "locked", message, id, className }: Props) {
  if (variant === "error") {
    if (!message) return null;
    return (
      <div
        role="alert"
        className={cn(
          "rounded-lg border border-destructive/40 bg-destructive/10 p-3 text-sm text-destructive",
          className,
        )}
      >
        <p>{message}</p>
        <p className="mt-1 text-xs">{SENSITIVE_FIELDS_SUPPORT_HINT}</p>
        <div className="mt-1 flex flex-wrap gap-3">
          <GestaoLink className="text-destructive" />
          <Link to="/suporte" className="inline-block font-medium underline">
            {SENSITIVE_FIELDS_SUPPORT_LINK_LABEL}
          </Link>
        </div>
      </div>
    );
  }

  if (variant === "admin") {
    return (
      <p id={id} className={cn("text-xs text-muted-foreground", className)}>
        {SENSITIVE_FIELDS_ADMIN_NOTICE} <GestaoLink />
      </p>
    );
  }

  return (
    <p id={id} className={cn("text-xs text-muted-foreground", className)}>
      {SENSITIVE_FIELDS_LOCKED_NOTICE} <GestaoLink />{" "}
      <Link to="/suporte" className="font-medium text-primary underline">
        {SENSITIVE_FIELDS_SUPPORT_LINK_LABEL}
      </Link>
      .
    </p>
  );
}
